var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_794_8",
    "data-name": "Component 794 \\u2013 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10834",
    "data-name": "Rectangle 10834",
    width: 13.815,
    height: 15.075,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15952",
    "data-name": "Group 15952",
    transform: "translate(5 4.462)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34930",
    "data-name": "Path 34930",
    d: "M44.349,39.739a5.238,5.238,0,0,0-.065-1.484,1.592,1.592,0,0,0-.246-.451c-1.149-1.21-2.318-2.277-3.507-3.446-.205-.226-.369-.472-.595-.677-.513-.472-1.251-.267-1.887-.349-1.087.021-2.154,0-3.241,0A1.522,1.522,0,0,0,33.8,33.7c-.021.041-.062.062-.1.1a.972.972,0,0,0-.246.554c-.123,3.836-.185,7.63-.021,11.466a1.229,1.229,0,0,0,.513.944,1.536,1.536,0,0,0,.677.205c.328.041.636.021.964.041.574.021,1.149,0,1.723,0,2.01.041,4,.041,6.01-.041A1.407,1.407,0,0,0,44.373,45.5",
    transform: "translate(-32.65 -32.649)",
    fill: "none",
    stroke: "#d0d2d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34931",
    "data-name": "Path 34931",
    d: "M365.737,72.791v3.854h3.558",
    transform: "translate(-358.235 -71.298)",
    fill: "none",
    stroke: "#d0d2d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34932",
    "data-name": "Path 34932",
    d: "M414.72,437.473a.971.971,0,1,0,.971.971.971.971,0,0,0-.971-.971m-.324.971a.324.324,0,1,1,.324.324.324.324,0,0,1-.324-.324",
    transform: "translate(-405.263 -428.5)",
    fill: "#d0d2d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34933",
    "data-name": "Path 34933",
    d: "M309.755,376.414a3.5,3.5,0,0,0-6.36,0,.445.445,0,0,0,0,.423,3.48,3.48,0,0,0,6.367,0,.445.445,0,0,0,0-.423m-3.18,1.85a1.791,1.791,0,1,1,2.558-1.634,2.97,2.97,0,0,1-2.558,1.634",
    transform: "translate(-297.118 -366.703)",
    fill: "#d0d2d6",
    stroke: "#d0d2d6",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34934",
    "data-name": "Path 34934",
    d: "M309.755,376.414a3.5,3.5,0,0,0-6.36,0,.445.445,0,0,0,0,.423,3.48,3.48,0,0,0,6.367,0A.445.445,0,0,0,309.755,376.414Zm-3.18,1.85a1.791,1.791,0,1,1,2.558-1.634A2.97,2.97,0,0,1,306.575,378.264Z",
    transform: "translate(-297.118 -366.703)",
    fill: "none"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10835",
    "data-name": "Rectangle 10835",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewFile);
export default __webpack_public_path__ + "static/media/view-file.b324769bd6e17376f46d85960aec3e5f.svg";
export { ForwardRef as ReactComponent };